export default "__VITE_ASSET__CuNwGQ0z__"